/* eslint-disable operator-linebreak */
import React, {
    useState,
    useEffect
} from 'react';

import {
    useIsMutating
} from 'react-query';

const SaveStates = {
    Saving: 'Saving',
    Saved: 'Saved',
    None: 'None'
};

const MIN_TIME_IN_SAVING_MS = 500;
const TIME_IN_SAVED_MS = 1500;

export default function SaveStatus() {
    const mutatingCount = useIsMutating();
    const isLoading = mutatingCount > 0;

    const [saveStatus, setSaveStatus] = useState({
        state: SaveStates.None,
        nextSaveState: null,
        lastStateTransitionAt: new Date()
    });

    function safeSetState(lastStateTransitionAt, newState, delay) {
        const timeoutId = setTimeout(() => {
            setSaveStatus(currentState => {
                if (currentState.lastStateTransitionAt !== lastStateTransitionAt || currentState.state === newState) {
                    return currentState;
                }

                return {
                    ...currentState,
                    lastStateTransitionAt: new Date(),
                    state: newState
                };
            });
        }, Math.max(delay, 0));

        return timeoutId;
    }

    useEffect(() => {
        let timeoutId;
        if (isLoading) {
            timeoutId = safeSetState(saveStatus.lastStateTransitionAt, SaveStates.Saving);
        } else if (saveStatus.state === SaveStates.Saving) {
            // If we're in saving state, only transition if it has been more than MIN_TIME_IN_SAVING_MS as we don't want to flash the "loading" status
            // in less time than the user can read it.
            const timeInStateMS = new Date() - saveStatus.lastStateTransitionAt;

            timeoutId = safeSetState(saveStatus.lastStateTransitionAt, SaveStates.Saved, MIN_TIME_IN_SAVING_MS - timeInStateMS);
        } else if (saveStatus.state === SaveStates.Saved) {
            timeoutId = safeSetState(saveStatus.lastStateTransitionAt, SaveStates.None, TIME_IN_SAVED_MS);
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };

    }, [isLoading, saveStatus.state, saveStatus.lastStateTransitionAt]);

    return (
        <div>
            {saveStatus.state === SaveStates.Saving
                ? <div className='tlw-mx-7.5'>
                    <span className='fa fa-circle-o-notch fa-spin'></span>
                    <span className='tlw-mx-2.5'>Saving...</span>
                </div>

                : <div className={`tlw-mx-7.5 tlw-transition-all tlw-duration-[400ms] tlw-ease-out ${saveStatus.state === SaveStates.Saved ? 'tlw-opacity-100' : 'tlw-opacity-0'}`}>
                    <span className='fa fa-check fa-color'></span>
                    <span className='tlw-mx-2.5'>Saved</span>
                </div>
            }
        </div>
    );
}
